<template>
    <div class="customerservicechatbox">

            
        <div class="chathead">
            <div class="chathead_inner">
                <div class="ailabel">营养素制造网官方客服</div>
            </div>
            <div class="closebtn" @click="close()">
                    <svgStyle :color="'rgba(0, 0, 0, 0.44)'" :width="16" :height="16"  :url="'#icon-Frame'"></svgStyle>   
            </div>
        </div>
        <div class="chatrecord" @scroll.passive="handleScroll" ref="scrollBox">
            <div class="recordlist">
                <div class="recordli" v-for="(item, index) in historyRecordList" :key="index">
                    <div class="time">{{ $parseTime99(item.sendTime) }}</div>
                    <div :class="shopInfo.id==item.userId?'chattextme':'chattextother'"   v-html="item.messageContent" ></div>
                </div>
            </div>
        </div>
        <div class="inputchatinfomationbox_outer">
            <div class="inputchatinfomationbox">
                <div class="faceupload">
                    <!-- <div class="face" style="margin-right: 16px;" >
                        <svgStyle :color="'rgba(0, 0, 0, 0.44)'" :width="16" :height="16"  :url="'#icon-biaoqing1'"></svgStyle>
                    </div> -->
                    <div class="upload">
                        <el-upload
                            :file-list="fileList"
                            :action="action"
                            :headers="headers"
                            multiple
                            :on-success="onSuccess"
                            :show-file-list="false"
                        >
                             <svgStyle :color="'rgba(0, 0, 0, 0.44)'" :width="16" :height="16"  :url="'#icon-tupian'"></svgStyle>
                        </el-upload>
                    </div>
                </div>
                <!-- <div
                    ref="editor"
                    class="editor"
                    contenteditable="true"
                    @input="onInput"
                     @click="saveRange"
                    @paste="handlePaste"
                ></div> -->
                <textarea name="" id="editor" class="editor" @input="onInput"    v-model="inputvalue"  @keydown.enter.exact.prevent="sendContent()"></textarea>
                <div class="fontnum">{{ wordarr.length }}/500</div>
                <el-button class="sendbutton" @click="sendContent()" type="primary">
                    <svgStyle      :width="16"  :height="16"  color="#fff"  :url="'#icon-fasong'"></svgStyle>
                    发送</el-button>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
:deep(.chattextme img){
    max-width: 260px;
}
:deep(.chattextother img){
    max-width: 260px;
}


.emoji-btn {
    background: none;
    border: none;
    font-size: 22px;
    cursor: pointer;
    margin-right: 4px;
}

.emoji-bar {
    display: flex;
    flex-wrap: wrap;
    padding: 8px 0 0 0;
    background: #fff;
    border-top: 1px solid #eee;
    gap: 6px;
    max-height: 120px;
    overflow-y: auto;
    font-family: "微软雅黑";
}

.emoji {
    font-size: 22px;
    cursor: pointer;
    padding: 2px 4px;
    border-radius: 4px;
    transition: background 0.2s;
}

.emoji:hover {
    background: #f5f5f5;
}

//客服样式
.customerservicechatbox {
    width: 480px;
    // height: 680px;
    font-size: 14px;
    background: #FFFFFF;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.16);
    position: fixed;
    right: 16px;
    bottom: 16px;
    z-index: 9999;
    position: fixed;

    .chathead {
        width: 478px;
        height: 56px;
        background: #FFFFFF;
        border-radius: 8px 8px 0px 0px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.04);
        display: flex;
        padding: 10px 16px 10px 16px;
        justify-content: space-between;
        align-items: center;
        position: absolute;

        .chathead_inner {
            display: flex;
            align-items: center;

            .aiicon {
                width: 36px;
                height: 36px;
                background: rgba(232, 37, 17, 1);
                border-radius: 50%;
                margin-right: 8px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .ailabel {
                font-family: 'AlibabaPuHuiTi-Medium';
                font-size: 16px;
                color: rgba(0, 0, 0, 0.88);
            }
        }

        .closebtn {
            span {
                font-size: 16px;
            }
        }

    }

    .inputchatinfomationbox_outer {
        height: 150px;
        bottom: 0px;
        position: absolute;
        background: #fff;
        width: 100%;

        .inputchatinfomationbox {
            position: absolute;
            width: 448px;
            height: 134px;
            background: #FFFFFF;
            box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.05);
            border-radius: 8px;
            border: 1px solid rgba(0, 0, 0, 0.08);
            left: 16px;
            bottom: 16px;

            .faceupload {
                padding-top: 12px;
                display: flex;
                padding-left: 12px;

                .face {
                    cursor: pointer;
                }

                .upload {
                    cursor: pointer;
                }
            }

            textarea {
                border: none;
                resize: none;
                outline: none;
                width: 448px;
                height: 58px;
                padding: 12px;
            }
            .editor{
                border: none;
                resize: none;
                outline: none;
                width: 448px;
                height: 58px;
                padding: 12px;
                overflow: auto;
            }

            .sendbutton {
                width: 72px;
                height: 36px;
                background: #D53C27;
                border-radius: 8px;
                border: 1px solid #FFFFFF;
                line-height: 36px;
                text-align: center;
                color: #FFFFFF;
                position: absolute;
                right: 12px;
                bottom: 12px;
                cursor: pointer;
            }

            .fontnum {
                height: 14px;
                font-weight: 400;
                font-size: 10px;
                color: rgba(0, 0, 0, 0.44);
                line-height: 14px;
                position: absolute;
                left: 12px;
                bottom: 9px;
            }
        }
    }

    .chatrecord {
        padding-top: 56px;
        height: 680px;
        padding-bottom: 150px;
        overflow-y: auto;

        .recordlist {
            padding: 0 32px;

            .recordli {
                margin-bottom: 24px;
                display: flex;
                flex-direction: column;
            }

            .chattextme {
                border-radius: 8px;
                border: 1px solid rgba(0, 0, 0, 0.04);
                padding: 16px;
                max-width: 300px;
                line-height: 20px;
                background: #D9E6FD;
                display: inline-block;
                align-self: flex-end;
                //强制换行
                word-break: break-all;
                img{
                    max-width: 300px!important;
                    object-fit: fill;
                }
            }
            .chattextother {
                border-radius: 8px;
                border: 1px solid rgba(0, 0, 0, 0.04);
                padding: 16px;
                max-width: 300px;
                line-height: 20px;
                background: #fff;
                display: inline-block;
                align-self: flex-start;
                word-break: break-all;
                img{
                    max-width: 300px!important;
                    object-fit: fill;
                }
            }

            .time {
                margin-bottom: 10px;
                text-align: center;
                height: 16px;
                font-weight: 400;
                font-size: 12px;
                color: rgba(0, 0, 0, 0.44);
                line-height: 16px;
            }
        }
    }
}
</style>
<script setup>
import { HTTP_REQUEST_URL,WS_REQUEST_URL } from '@/config/app.js';
import { ref, nextTick, watch, onBeforeUnmount,onMounted } from 'vue';
import { sendMessageApi,queryHistoryListApi } from '@/api/message/onlineservice.js'
let fileList=ref([]);
let action=HTTP_REQUEST_URL + '/admin-api/infra/file/upload';
let token=localStorage.getItem("ACCESS_TOKEN");
let headers= ref({
    authorization: 'Bearer ' + token
});

function onSuccess(file) {
    // insertImageToEditor(file.data)
      //发送图片
      let imgobj='<img src="'+file.data+'" style="max-width: 120px;vertical-align: middle;">'
    sendImage(imgobj)

}
// 插入图片到 contenteditable
let lastRange = null

function saveRange() {
  const sel = window.getSelection()
  if (sel.rangeCount > 0) {
    lastRange = sel.getRangeAt(0)
  }
}
function insertImageToEditor(url) {
     editor.value && editor.value.focus()
  // 恢复光标
  if (lastRange) {
    const sel = window.getSelection()
    sel.removeAllRanges()
    sel.addRange(lastRange)
  }
  // 插入图片
  const sel = window.getSelection()
  if (!sel.rangeCount) return
  const img = document.createElement('img')
  img.src = url
  img.style.maxWidth = '120px'
  img.style.verticalAlign = 'middle'
  const range = sel.getRangeAt(0)
  range.collapse(false)
  range.insertNode(img)
  // 光标移到图片后
  range.setStartAfter(img)
  range.collapse(true)
  sel.removeAllRanges()
  sel.addRange(range)
  // 更新 lastRange
  lastRange = range
  inputvalue.value = editor.value.innerHTML
}
let inputvalue = ref("");
const editor = ref(null)
//弹窗相关
function onInput(e) {
//   inputvalue.value = e.target.innerHTML;
  changeNum();
}
const props = defineProps({
    modelValue: { type: Boolean, default: false }
})
const emit = defineEmits(['update:modelValue', 'close'])
function close() {
    emit('update:modelValue', false)
    emit('close')
}
//计算输入的字数
let wordarr = ref([]);
function changeNum() {
    wordarr.value = inputvalue.value.split("")
}
//判断当前用户是否登录 ，没有登录则没有聊天记录
let userinfo = {};
console.log(JSON.parse(sessionStorage.getItem('shopInfo')));
let shopInfo = JSON.parse(sessionStorage.getItem('shopInfo'));
const wsUrl = WS_REQUEST_URL + '/infra/ws?token=' + token
const ws = ref(null);

let historyRecordList = ref([]);
//获取聊天历史记录
let queryParams = {
    pageNo: 1,
    pageSize: 10,
    shopId:shopInfo.shopInfo.id,
    userId:shopInfo.id,
    messageType:3
}
async function queryHistoryList() {
    let { data,code } = await queryHistoryListApi(queryParams);
    if (code == 0) {
        historyRecordList.value = data.list.reverse();
        nextTick(() => {
            if (scrollBox.value) { scrollBox.value.scrollTop = scrollBox.value.scrollHeight }
        });
    }
}

//上拉滚动
const scrollBox = ref(null)
const loadingHistory = ref(false)
const hasMoreHistory = ref(true) // 是否还有历史消息
async function fetchHistory() {
    if (loadingHistory.value || !hasMoreHistory.value) return
    loadingHistory.value = true;
    // 1. 记录当前滚动高度
    const oldHeight = scrollBox.value.scrollHeight
    // 2. 请求历史消息（假设接口返回历史消息数组）
    queryParams.pageNo=1+queryParams.pageNo;
    const {data} = await queryHistoryListApi(queryParams); // 你自己的接口
    if (data.list.length === 0) hasMoreHistory.value = false
    // 3. 插入到头部
    historyRecordList.value = [...data.list.reverse(), ...historyRecordList.value]
    // 4. nextTick 后恢复滚动位置
    nextTick(() => {
        const newHeight = scrollBox.value.scrollHeight
        scrollBox.value.scrollTop = newHeight - oldHeight
        loadingHistory.value = false
    })
}
function handleScroll() {
    if (scrollBox.value.scrollTop === 0) {
            fetchHistory();
    }
}
//发送消息
async function sendContent() {
    if (!inputvalue.value.trim()) return;
    const postdata = {
        "messageContent": inputvalue.value, //消息内容
        "userId": shopInfo.id, //用户ID（发送者id）
        "messageType": 3, //消息类型(1：商户个人消息 2：系统公告所有人消息3：后台管理员消息)
        "shopId":shopInfo.shopInfo.id,
    }
    let { data,code } = await sendMessageApi(postdata);
    if (code == 0) {
            historyRecordList.value.push({
                messageContent:inputvalue.value,
                sendTime:(new Date()).getTime(),
                userId:shopInfo.id,
                shopId:shopInfo.shopInfo.id,
            })
            inputvalue.value="";
            if (editor.value) {
                editor.value.innerHTML = "";
            }
            wordarr.value=[];
            nextTick(() => {
                if (scrollBox.value) { scrollBox.value.scrollTop = scrollBox.value.scrollHeight }
            });

    }
}
async function sendImage(img){

const postdata = {
        "messageContent": img, //消息内容
        "userId": shopInfo.id, //用户ID（发送者id）
        "messageType": 3, //消息类型(1：商户个人消息 2：系统公告所有人消息3：后台管理员消息)
        "shopId":shopInfo.shopInfo.id,

}
let { data, code } = await sendMessageApi(postdata);
    historyRecordList.value.push({
        messageContent: img,
        sendTime: (new Date()).getTime(),
        userId: shopInfo.id,
        shopId: shopInfo.shopInfo.id,
        })
    nextTick(() => {
        if (scrollBox.value) { scrollBox.value.scrollTop = scrollBox.value.scrollHeight }
    });
}
function insertMessage(str){
    let sendObject=JSON.parse(str);
    historyRecordList.value.push(sendObject)
            nextTick(() => {
                if (scrollBox.value) { scrollBox.value.scrollTop = scrollBox.value.scrollHeight }
            });
}


onMounted(async () => {
   
    ws.value = new WebSocket(wsUrl);
    ws.value.onmessage = (event) => {
        try { const msg = JSON.parse(event.data);
            insertMessage(msg.content);
        } catch (e) {}
    }
    ws.value.onerror = (e) => {
        console.error('WebSocket error:', e)
    }
    ws.value.onclose = () => {
        console.warn('WebSocket closed')
    }
    queryHistoryList();
})
onBeforeUnmount(() => {ws.value && ws.value.close()})
</script>